import { jQuery as $ } from '@tao/plattform';

class Hotspot {
	constructor( el ) {
		this.el = el;

		const $spots = $( this.el ).children( 'i' );

		this.spots = $.map( $spots, ( spot ) => {
			return new HotspotNote( spot, this );
		} );

		$( this.el ).find( '.filter .toggle' ).on( 'click', function() {
			$( this ).toggleClass( 'closed' );
			$( this ).parent().parent().find( '.option' ).slideToggle();
		} );
		$( this.el ).find( '.filter .option' ).on( 'click', function() {
			$( this ).toggleClass( 'selected' );
			$( this ).parent().parent().find( '.' + $( this ).attr( 'rel' ) ).toggleClass( 'hidden' );
		} );
	}
}

class HotspotNote {
	isOpen = false;

	constructor( el, hotspot ) {
		this.spot = $( el );
		this.note = $( '#' + this.spot.attr( 'rel' ) );

		this.hotspot = hotspot;

		$( this.spot ).on( 'click', this.toggle );
		$( this.note ).on( 'click', '.close', this.close );
	}

	toggle = () => {
		if ( this.isOpen ) {
			this.close();
		} else {
			this.open();
		}
	};

	open = () => {
		const $spot = this.spot;
		const $note = this.note;

		const x = $spot.attr( 'data-x' );
		const y = $spot.attr( 'data-y' );

		$( '.notes i.plus' ).removeClass( 'active' );
		$spot.closest( '.notes' ).removeClass( 'open' );
		$spot.closest( '.notes' ).find( '.note' ).fadeOut();

		if ( 50 < x ) {
			$note.css( {
				right: 100 - x + '%',
				left: 'initial',
			} );
		} else {
			$note.css( {
				left: x + '%',
			} );
		}
		if ( 50 < y ) {
			$note.css( {
				bottom: 100 - y + '%',
				top: 'initial',
			} );
		} else {
			$note.css( {
				top: y + '%',
			} );
		}

		$spot.addClass( 'active' );
		$spot.closest( '.notes' ).addClass( 'open' );
		$note.fadeIn();

		this.isOpen = true;
	};

	close = () => {
		const $spot = this.spot;
		const $note = this.note;

		$note.fadeOut();
		$spot.removeClass( 'active' );
		$spot.closest( '.notes' ).removeClass( 'open' );

		this.isOpen = false;
	};
}

Hotspot.Note = HotspotNote;

Hotspot.init = () => {
	$( '.acf-hotspot' ).each( function() {
		// eslint-disable-next-line

		const hotspotObject = new Hotspot( this );
		$( this ).data( 'hotspot', hotspotObject );
	} );
};

export default Hotspot;
